import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface ShareIconProps extends SvgIconProps {}

export const ShareIcon = ({}: ShareIconProps): ReactElement => {
  return (
    <SvgIcon
      style={{ fontSize: '1.5em' }}
      width="35"
      height="35"
      viewBox="0 0 35 35"
    >
      <g>
        <g
          transform="translate(0 0)"
          fill="#f0f0f0"
          stroke="#fff"
          strokeWidth="1"
        >
          <rect width="35" height="35" rx="17.5" stroke="none" />
          <rect x="0.5" y="0.5" width="34" height="34" rx="17" fill="none" />
        </g>
      </g>
      <g transform="translate(7 7.001)">
        <path
          d="M19.081,7.649l-9.406,4.7-.56-1.119,9.406-4.7.56,1.117Zm-.56,11.625-9.406-4.7.561-1.119,9.406,4.7-.56,1.117Z"
          transform="translate(-4.051 -2.903)"
          fill="#a7a7a7"
          fillRule="evenodd"
        />
        <path
          d="M16.875,6.25A3.125,3.125,0,1,0,13.75,3.125,3.125,3.125,0,0,0,16.875,6.25Zm0,13.75a3.125,3.125,0,1,0-3.125-3.125A3.125,3.125,0,0,0,16.875,20ZM3.125,13.125A3.125,3.125,0,1,0,0,10a3.125,3.125,0,0,0,3.125,3.125Z"
          fill="#a7a7a7"
          fillRule="evenodd"
        />
      </g>
    </SvgIcon>
  );
};
